import { SUBSCRIPTION_PAYMENT_FORM_PATH } from 'Pods/SubscriptionCheckout/Constants/paths'

export const TODO_LEARN_MORE_HREF = '#'
export const AI_TERMS_OF_SERVICE_HREF = 'https://www.cgtrader.com/pages/cgtrader-ai-terms-of-service'
export const STUDIO_RETURN_URL = '/ai'
export const RETURN_URL_QUERY = `return_url=${encodeURIComponent(STUDIO_RETURN_URL)}`

export function buildSubscriptionHref(subscriptionPaymentFormUrl) {
  return `${subscriptionPaymentFormUrl || SUBSCRIPTION_PAYMENT_FORM_PATH}?${RETURN_URL_QUERY}`
}
